var _g, _g2, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCupPodiumNew = function SvgCupPodiumNew(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 175,
    viewBox: "0 0 138 175",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5513_14830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.696 172.369H72.1573H36.5L50.5578 141.288L3.04541 143.619L26.0001 124.488L33.1391 124.636L92.6351 124.488L112.5 124.636L135.638 141.288H89.9672L102.696 172.369Z",
    fill: "url(#paint0_linear_5513_14830)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.428 79.59H104.501L99.7642 74.4883L125.772 74.4883L133.428 79.59Z",
    fill: "url(#paint1_linear_5513_14830)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.428 79.5938H104.501L95.1235 125.596H115.012L133.428 79.5938Z",
    fill: "url(#paint2_linear_5513_14830)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7639 74.4883L89.5986 116.753L95.4051 125.528L104.501 79.59L99.7639 74.4883Z",
    fill: "url(#paint3_linear_5513_14830)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3023 125.543L48.7159 125.543L40.2447 77.7749L7.09652 77.7749L23.3023 125.543Z",
    fill: "url(#paint4_linear_5513_14830)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09668 77.7315L40.2448 77.7315L51.2919 71.832L15.9746 71.832L7.09668 77.7315Z",
    fill: "url(#paint5_linear_5513_14830)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2917 71.832L54.3431 117.899L48.837 125.542L40.2446 77.3438L51.2917 71.832Z",
    fill: "url(#paint6_linear_5513_14830)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.854 66.6082H42.4082L49.8725 58.9297H93.3892L100.854 66.6082Z",
    fill: "url(#paint7_linear_5513_14830)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.854 66.6094H42.4082L54.6093 132.593H90.3356L100.854 66.6094Z",
    fill: "url(#paint8_linear_5513_14830)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0738 89.0074V89.4063L76.0057 89.7094L75.8415 89.849L75.6773 89.9647L75.5131 90.0365H74.8324L73.8232 89.9886H73.4468L70.2833 89.9448H69.9149L67.5442 90.0365L66.7714 89.9886L66.5111 89.9208L66.419 89.849L66.3709 89.7094L66.3469 89.4741V88.9396L66.3949 88.2375L66.3709 87.8626L66.2788 87.1645V86.8135L66.3028 86.65L66.3949 86.3907L66.6552 86.3428L67.5923 86.4146H67.9687L68.5053 86.3907L68.7896 86.3428L68.9298 86.275L68.9979 86.1115V84.4521L69.0219 84.0772L69.118 82.6771V82.3261L69.094 81.8115L69.0459 81.4605L69.0219 80.8781L68.9979 80.5032L69.0459 79.8969L69.094 79.0991V78.8398L69.0219 78.7002L68.8817 78.6085L68.6695 78.5845L67.8245 78.8638L67.4761 78.9555L67.1238 79.0034H66.8194L66.6072 78.9116L66.5111 78.7481L66.443 78.5127L66.419 78.3253V77.9543L66.467 77.3679V76.9691L66.419 76.2431V75.8442L66.467 75.5411L66.5591 75.4015L66.6753 75.3097L66.9115 75.19L67.1117 75.1222L67.4641 74.9826L68.1409 74.7712L68.4693 74.6555L69.7147 74.1848L70.067 74.0692L71.3084 73.6703L71.6608 73.5267L72.2014 73.2714L72.6019 73.1079L72.9543 73.0161L73.2386 72.9922L73.4709 73.06L73.587 73.2235L73.6591 73.5068L73.7071 73.786L73.6831 74.0652L73.635 74.9786L73.611 75.3496V78.9954L73.5429 80.4194V80.7944L73.635 82.2423L73.611 82.6173L73.5189 84.0413L73.4949 84.4162L73.587 85.8642L73.611 86.0995L73.6831 86.2391L73.8232 86.3309L74.1036 86.3548L75.7934 86.3787L75.9336 86.4266L76.0297 86.638L76.0537 86.8016L76.0738 87.1526L76.0297 87.8506V88.2256L76.0738 89.0074Z",
    fill: "#201366"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5513_14830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.152 0.018142L97.8551 1.03372C97.3716 1.11097 96.9245 1.34431 96.5785 1.7C96.2325 2.05569 96.0055 2.5153 95.9304 3.01235L95.5216 7.39335C95.4417 7.90595 95.2248 8.38566 94.8952 8.77894C94.5656 9.17223 94.1361 9.46362 93.6547 9.62062L90.3163 10.5942C89.3761 10.8708 88.4563 11.6938 88.2723 12.4362C88.0884 13.1786 88.7016 13.5919 89.6554 13.3643L96.0223 11.8269C96.5082 11.6945 96.9476 11.4232 97.2895 11.0445C97.6314 10.6658 97.8618 10.1951 97.9539 9.68716L98.4887 5.11355C98.5745 4.6185 98.8124 4.16473 99.1673 3.81874C99.5223 3.47275 99.9757 3.25274 100.461 3.19095L101.824 3.04037C102.801 2.93181 106.981 1.81467 106.9 2.77071V1.49599C106.901 1.27316 106.854 1.05285 106.762 0.851079C106.67 0.649311 106.535 0.471162 106.368 0.329603C106.2 0.188044 106.004 0.0866357 105.794 0.0327568C105.584 -0.021122 105.364 -0.026115 105.152 0.018142Z",
    fill: "#F8CC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.428 5.07812C101.288 27.2213 87.6417 29.7462 82.7055 29.9423C81.7244 29.9773 80.9272 30.5481 80.9272 31.3431C80.9272 32.1381 81.7244 32.7859 82.7089 32.7439C101.507 31.6933 105.738 14.1553 106.668 5.10614L103.428 5.07812Z",
    fill: "#DD7516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3604 12.4358C53.1696 11.6934 52.2533 10.8704 51.3164 10.5937L47.978 9.62017C47.4966 9.46318 47.0672 9.17178 46.7375 8.7785C46.4079 8.38521 46.191 7.9055 46.1112 7.3929L45.7024 3.0119C45.6282 2.51442 45.4016 2.05425 45.0554 1.69837C44.7092 1.34249 44.2616 1.10949 43.7776 1.03328L36.4841 0.0176963C35.5098 -0.118882 34.7024 0.550001 34.7297 1.50955V2.77377C34.6479 1.81772 38.8176 2.94537 39.7987 3.05393L41.1614 3.20451C41.6462 3.267 42.0989 3.48733 42.4531 3.83326C42.8074 4.17919 43.0447 4.63258 43.1304 5.12711L43.6686 9.70072C43.7629 10.2073 43.995 10.676 44.3382 11.0523C44.6813 11.4286 45.1213 11.6971 45.607 11.8264L51.9875 13.3498C52.9312 13.5774 53.5512 13.1747 53.3604 12.4358Z",
    fill: "#F8CC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9172 29.9256C53.9947 29.747 40.3682 27.0575 38.1744 5.08594L34.979 5.26454C35.9465 14.3697 40.2456 31.6836 58.9172 32.7167C59.8983 32.7692 60.6954 32.1213 60.6954 31.3159C60.6954 30.5104 59.9119 29.9606 58.9172 29.9256Z",
    fill: "#DD7516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.152 1.13453L97.8546 2.15011C97.3711 2.22736 96.924 2.4607 96.578 2.81639C96.232 3.17208 96.005 3.63168 95.9299 4.12873L95.5211 8.50623C95.4418 9.01947 95.2252 9.49991 94.8955 9.89386C94.5658 10.2878 94.1361 10.5797 93.6542 10.737L90.3158 11.7106C89.3756 11.9872 88.4558 12.8102 88.2718 13.5526C88.0879 14.295 88.701 14.7083 89.6549 14.4806L96.0218 12.9573C96.5077 12.8249 96.9471 12.5536 97.289 12.1749C97.6309 11.7962 97.8613 11.3255 97.9534 10.8175L98.4882 6.24394C98.573 5.74843 98.8105 5.29407 99.1657 4.94789C99.5208 4.60172 99.9748 4.38207 100.461 4.32134L101.823 4.17076C102.801 4.0622 103.55 4.75209 103.465 5.71163C101.486 28.303 87.6723 30.8595 82.685 31.0416C81.7039 31.0766 80.9067 31.6474 80.9067 32.4424C80.9067 33.2373 81.7039 33.8852 82.6884 33.8432C104.47 32.635 106.691 9.26616 106.875 2.63688C106.879 2.41451 106.835 2.19398 106.746 1.99128C106.657 1.78858 106.525 1.6088 106.36 1.46497C106.195 1.32114 106.001 1.21686 105.792 1.15971C105.583 1.10255 105.364 1.09395 105.152 1.13453Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.329 11.1243L95.0543 10.7461L92.2268 11.9963L95.0543 11.5095L92.1382 12.7142H94.7204L92.0156 13.4146L94.809 12.9839L91.9338 13.9014C91.9338 13.9014 91.0004 11.5095 92.329 11.1243Z",
    fill: "#ED9118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0891 31.0547L85.1074 31.1317L82.314 31.9267L85.1074 31.8952L82.2254 32.6446L84.7701 33.0999L82.1028 33.3555L84.8621 33.38L82.021 33.8353C82.021 33.8353 80.7606 31.4364 82.0891 31.0547Z",
    fill: "#ED9118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4761 1.1348L43.7696 2.15038C44.2535 2.2266 44.7012 2.4596 45.0474 2.81548C45.3935 3.17136 45.6202 3.63153 45.6943 4.12901L46.1031 8.50651C46.1824 9.01974 46.399 9.50019 46.7287 9.89414C47.0584 10.2881 47.4881 10.58 47.97 10.7373L51.3084 11.7108C52.2521 11.9875 53.1684 12.8105 53.3524 13.5529C53.5363 14.2953 52.9231 14.7085 51.9659 14.4809L45.6058 12.9575C45.1195 12.826 44.6797 12.5549 44.3377 12.176C43.9957 11.7972 43.7656 11.3261 43.6742 10.8178L43.136 6.24422C43.0514 5.74922 42.8144 5.29525 42.4599 4.94913C42.1054 4.60301 41.6522 4.38305 41.167 4.32162L39.8043 4.17104C38.83 4.06247 38.0806 4.75236 38.1623 5.71191C40.145 28.3033 53.9588 30.8598 58.9426 31.0419C59.9271 31.0769 60.7209 31.6477 60.7209 32.4427C60.7209 33.2376 59.9237 33.8855 58.9426 33.8435C37.1608 32.6353 34.9363 9.26644 34.7557 2.63716C34.7046 1.67061 35.5018 0.998226 36.4761 1.1348Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8488 11.222L47.1235 10.8438L49.9476 12.094L47.1235 11.6072L50.0396 12.8119H47.4574L50.1622 13.5123L47.3654 13.085L50.244 13.992C50.244 13.992 51.1774 11.6107 49.8488 11.222Z",
    fill: "#DD7516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.089 31.1523L57.0708 31.2294L59.8608 32.0278L57.0708 31.9928L59.9528 32.7458L57.4046 33.187L60.0754 33.4462L57.3161 33.4707L60.1572 33.9224C60.1572 33.9224 61.4142 31.5411 60.089 31.1523Z",
    fill: "#DD7516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3 57.422L57.548 57.1523L54.9521 61.0956C54.9521 61.0956 69.7436 64.8042 87.5908 61.1411L84.3 57.422Z",
    fill: "#9B481E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9359 61.9413C69.4677 61.0658 65.6489 57.8124 64.5622 56.2891L57.5617 57.1541L54.9658 61.0973C54.9658 61.0973 66.7254 64.2246 81.9359 61.9413Z",
    fill: "#7F300F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2999 57.4224C79.9225 58.1762 75.4899 58.5394 71.0516 58.5081C66.5201 58.4704 62.0009 58.0169 57.5479 57.1528C61.7651 55.2289 66.3288 54.2386 70.9426 54.2461C75.5536 54.4018 80.0908 55.4807 84.2999 57.4224Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7388 52.8357C77.7388 52.8357 77.715 55.0174 79.6431 55.5147C79.6431 55.5147 72.0464 58.2637 62.249 55.245C62.249 55.245 63.891 54.8178 64.0613 52.5625L77.7388 52.8357Z",
    fill: "#DD7516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.657 40.2539H63.9692C66.6945 42.4742 68.3978 44.754 68.3978 46.9427C68.4523 51.7124 64.1396 52.721 64.0544 52.5774C64.0544 52.5774 70.9698 54.8152 77.7319 52.8506C77.6501 52.9872 73.3374 52.0451 73.2795 47.0023C73.2693 44.7785 74.9487 42.4917 77.657 40.2539Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0402 39.5199C76.4648 42.3005 65.5466 42.0168 62.6442 39.5199C61.9356 38.8965 61.9356 36.5957 62.6442 35.9689C65.5432 33.3949 76.4648 33.1393 79.0402 35.9689C79.6704 36.6553 79.6704 38.83 79.0402 39.5199Z",
    fill: "#DD7516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7523 41.6406C68.4556 43.5002 69.2868 45.2792 69.3004 46.9812C69.3277 49.8913 67.9378 51.5163 66.5547 52.3848C67.4352 52.5474 68.3232 52.6643 69.2152 52.735L69.1812 52.6509C69.5314 50.7811 69.6821 48.8776 69.6308 46.9742C69.6083 45.2964 69.4854 43.6216 69.2629 41.9593C68.4211 41.8997 67.5829 41.7934 66.7523 41.6406Z",
    fill: "#ED9118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4759 35.8829C78.1374 39.546 63.983 39.2098 60.2255 35.8829C59.3057 35.067 59.3057 32.0833 60.2255 31.2673C63.9727 27.9334 78.1374 27.6007 81.4759 31.2673C82.2934 32.1673 82.2934 34.9829 81.4759 35.8829Z",
    fill: "#DD7516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0596 38.3242C63.0791 38.5027 63.1385 38.6741 63.2333 38.825C64.4256 39.8756 67.7062 40.576 71.2048 40.597C74.6114 40.597 77.4252 39.9421 78.3859 38.8915C78.4603 38.7763 78.5103 38.6463 78.5324 38.5098C76.1805 39.1585 73.7518 39.465 71.3172 39.4203C68.5282 39.4562 65.7482 39.0872 63.0596 38.3242Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6768 4.87076C92.6768 19.0609 87.6044 34.4066 70.8133 34.4066C54.0221 34.4066 48.9497 19.0609 48.9497 4.87076C63.1945 0.35558 78.432 0.35558 92.6768 4.87076Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6768 4.87076C92.6768 19.0609 87.6044 34.4066 70.8133 34.4066C54.0221 34.4066 48.9497 19.0609 48.9497 4.87076C63.1945 0.35558 78.432 0.35558 92.6768 4.87076Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7573 21.5368C91.8489 16.5149 92.6768 10.6001 92.6768 4.87081C85.5878 2.65536 78.2224 1.51455 70.8132 1.48438C69.9911 1.48437 69.1814 1.49955 68.3843 1.5299C69.195 6.35915 72.9287 19.1379 89.7573 21.5368Z",
    fill: "#F7B53C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9872 4.85547H48.9497C48.9497 19.0456 54.0221 34.3913 70.8133 34.3913C78.6757 34.3913 83.9662 31.0294 87.3728 25.9865C79.78 25.9675 72.3081 24.0304 65.6147 20.3457C58.9212 16.6609 53.2112 11.3415 48.9872 4.85547Z",
    fill: "#ED9118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.474 32.9258C60.3514 33.8258 60.5285 34.9289 60.8147 35.1811C62.4362 36.6169 66.657 37.5835 71.3275 37.5835C75.8037 37.5835 79.5306 36.6659 80.8251 35.2476C81.1214 34.9219 81.2645 33.8258 81.1657 32.9293C78.1849 34.5227 74.7136 35.3317 70.8267 35.3317C66.9397 35.3317 63.4514 34.5227 60.474 32.9258Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8133 8.25752C63.404 8.22775 56.0386 7.08693 48.9497 4.87109C55.9476 7.54714 63.3471 8.94332 70.8133 8.99645C78.2794 8.94282 85.6788 7.54665 92.6768 4.87109C85.5879 7.08654 78.2225 8.22735 70.8133 8.25752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.379 4.87132C83.345 6.67193 77.0961 7.59838 70.813 7.62389C64.5294 7.60157 58.2794 6.67867 52.2437 4.88183C64.3649 1.22168 77.2543 1.22168 89.3756 4.88183L89.379 4.87132Z",
    fill: "#DD7516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9341 6.4843C62.8535 7.22139 66.8285 7.60224 70.8129 7.62245C74.7914 7.60562 78.7607 7.22828 82.6747 6.49481C74.8287 4.99131 66.78 4.99131 58.9341 6.49481V6.4843Z",
    fill: "#C15F0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1396 41.8516C74.1697 41.9968 73.19 42.0624 72.21 42.0477C72.5166 42.629 72.4007 44.5971 72.3053 45.6793C72.7448 43.1753 75.1396 41.8516 75.1396 41.8516Z",
    fill: "#F8BF47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2419 52.5533C74.4239 52.7198 73.5924 52.8066 72.7585 52.8125C73.0515 52.3642 72.6393 50.186 72.5269 49.1914C72.997 51.4467 75.2419 52.5533 75.2419 52.5533Z",
    fill: "#F8BF47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0642 53.5273C75.6149 53.94 74.1101 54.108 72.6084 54.0246C72.6084 54.0246 72.6084 55.7756 72.9014 56.0873C72.9014 56.0873 76.1853 56.2589 78.6687 55.4219C78.6687 55.4219 76.9723 54.8231 77.0642 53.5273Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2681 56.9065C60.244 56.4678 61.2425 56.0844 62.2591 55.7578C62.2591 55.7578 64.9503 57.0781 71.0413 56.8084C71.0413 56.8014 66.5616 57.8135 59.2681 56.9065Z",
    fill: "#DD7516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1631 2.37009C97.1631 2.37009 101.493 0.864237 105.68 1.13389C105.69 1.1409 98.2157 2.39111 97.1631 2.37009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1201 1.11717C36.1201 1.11717 41.1994 2.20629 44.33 2.31486C44.33 2.31486 37.2375 0.91756 36.1201 1.11717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8096 13.0781C50.8096 13.0781 55.3131 29.6881 64.6813 31.4391C64.6813 31.4391 56.4202 25.8954 50.8096 13.0781Z",
    fill: "#F4A024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5286 7.50021L82.3647 6.14844L81.0498 8.03251L82.3647 9.91659L80.5286 8.56482L78.6958 9.91659L80.0108 8.03251L78.6958 6.14844L80.5286 7.50021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.475 0.84062L106.429 0.136719L105.744 1.11728L106.429 2.09434L105.475 1.39394L104.525 2.09434L105.206 1.11728L104.525 0.136719L105.475 0.84062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2747 1.46602L40.2251 0.765625L39.5438 1.74268L40.2251 2.72324L39.2747 2.01934L38.3242 2.72324L39.0055 1.74268L38.3242 0.765625L39.2747 1.46602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7356 52.6182L78.6724 52.1315L78.0047 52.8599L78.6996 53.6863L77.7424 53.056L76.809 53.5112L77.4733 52.8143L76.7783 51.9844L77.7356 52.6182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7178 53.5207C70.7178 53.5207 74.4139 53.7483 77.6127 52.8203C77.6264 52.8273 75.9026 54.1756 70.7178 53.5207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5479 57.1523C57.5479 57.1523 70.0841 60.1711 84.2999 57.422C84.2999 57.422 71.8351 60.896 57.5479 57.1523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9941 11.5122C77.9941 11.5122 83.7683 12.055 89.379 9.91881C89.379 9.91881 87.5326 12.5663 82.0889 13.4208C82.0889 13.4208 85.9963 13.694 88.5308 13.2667C88.5308 13.2667 86.4868 15.3119 84.201 15.3119C84.201 15.3119 86.5856 15.8442 89.379 14.1457C90.746 12.2579 91.5047 9.97799 91.549 7.625C88.5819 8.99778 85.8736 10.0764 77.9941 11.5122Z",
    fill: "#F8CC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2065 35.5949C75.2233 35.5956 78.2025 34.9054 80.9274 33.5742C80.9274 33.5742 80.9035 34.6668 80.6276 34.975C80.3516 35.2832 76.0457 36.9571 72.0361 36.8521C72.0361 36.8521 74.5434 36.5019 75.8958 35.8995C74.6608 35.8833 73.4282 35.7815 72.2065 35.5949Z",
    fill: "#F8BF47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.497 38.9961C77.4529 39.1338 77.3777 39.2589 77.2777 39.3611C77.1776 39.4634 77.0555 39.5399 76.9213 39.5844C76.4955 39.686 73.6169 40.1903 71.4707 39.9066C71.4605 39.9066 75.7699 39.658 77.497 38.9961Z",
    fill: "#F8BF47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6956 57.169C82.6956 57.169 80.3859 55.9503 79.4048 55.8242C79.4048 55.8242 77.7015 56.6192 73.2729 56.6857C73.8564 57.2369 74.5831 57.6019 75.3646 57.7363C75.3646 57.7363 80.2531 57.7783 82.6956 57.169Z",
    fill: "#F8BF47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.209 59.104C78.0288 59.9652 79.9488 60.5819 81.9218 60.939C81.9218 60.939 85.0082 61.1141 85.9655 60.7604L83.7171 58.4141L84.6233 60.4732L81.6595 59.0724L83.4514 60.2456C83.4514 60.2456 79.2375 60.088 76.209 59.104Z",
    fill: "#B25932"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M55.4767 24.2874C57.2389 22.5128 57.2389 19.6356 55.4767 17.8611C53.7145 16.0865 50.8573 16.0865 49.0951 17.8611C47.3329 19.6356 47.3329 22.5128 49.0951 24.2874C50.8573 26.0619 53.7145 26.0619 55.4767 24.2874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M91.0631 7.54517C92.8254 5.7706 92.8254 2.89346 91.0631 1.11889C89.3009 -0.655679 86.4438 -0.655676 84.6815 1.11889C82.9193 2.89346 82.9193 5.7706 84.6815 7.54517C86.4438 9.31974 89.3009 9.31974 91.0631 7.54517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M53.9327 23.9966C55.6338 23.2912 56.445 21.3307 55.7446 19.6177C55.0441 17.9047 53.0972 17.0878 51.3961 17.7931C49.695 18.4985 48.8838 20.459 49.5842 22.172C50.2847 23.8851 52.2316 24.702 53.9327 23.9966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M89.5191 7.25833C91.2202 6.55296 92.0315 4.59246 91.331 2.87942C90.6305 1.16638 88.6837 0.34949 86.9825 1.05485C85.2814 1.76022 84.4702 3.72073 85.1706 5.43377C85.8711 7.14681 87.818 7.96369 89.5191 7.25833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M52.6632 18.5962C52.5198 19.6191 52.6632 20.8957 50.8574 21.0553C51.3923 21.3066 51.9897 21.5261 52.3629 22.0303C52.6941 22.4796 52.9643 23.2352 53.0206 23.7857C53.122 23.1921 52.9849 22.6383 53.3494 22.0303C53.4813 21.8061 53.6622 21.6151 53.8783 21.4716C54.0943 21.3281 54.3399 21.236 54.5966 21.2021C54.0189 20.883 53.5166 20.9308 53.1664 20.2359C53.0294 19.9733 52.9156 19.6991 52.8264 19.4164C52.7409 19.1316 52.771 18.6887 52.5887 18.4805L52.6632 18.5962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M88.2496 1.85788C88.1062 2.8808 88.2496 4.15745 86.4438 4.31703C86.9787 4.56837 87.5761 4.78779 87.9493 5.29206C88.2805 5.74128 88.5507 6.4969 88.607 7.04745C88.7084 6.45381 88.5713 5.90007 88.9358 5.29206C89.0678 5.06786 89.2486 4.8768 89.4647 4.73332C89.6807 4.58983 89.9264 4.49769 90.183 4.46384C89.6053 4.14468 89.103 4.19255 88.7528 3.49758C88.6158 3.23501 88.502 2.96081 88.4129 2.67813C88.3273 2.39328 88.3574 1.95044 88.1751 1.74219L88.2496 1.85788Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5513_14830",
    x1: 69.3417,
    y1: 124.488,
    x2: 69.3417,
    y2: 172.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155755,
    stopColor: "#1B1059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1059",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5513_14830",
    x1: 84847,
    y1: 10920.7,
    x2: 84843.9,
    y2: 12714.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3C9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5513_14830",
    x1: 106.161,
    y1: 79.1622,
    x2: 99.5009,
    y2: 117.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5513_14830",
    x1: 15125.2,
    y1: 59532,
    x2: 7735.94,
    y2: 57348.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#201366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5513_14830",
    x1: 25.5,
    y1: 78,
    x2: 18.0633,
    y2: 123.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5513_14830",
    x1: 111266,
    y1: 12614.1,
    x2: 111263,
    y2: 14688.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3C9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5513_14830",
    x1: 14264.6,
    y1: 62639.2,
    x2: 7164.72,
    y2: 60753.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#201366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5513_14830",
    x1: 147176,
    y1: 16383.4,
    x2: 147171,
    y2: 19083.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A3C9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A3C9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5513_14830",
    x1: 59.2493,
    y1: 65.9904,
    x2: 50.2383,
    y2: 121.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F338C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201366"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5513_14830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138,
    height: 116,
    fill: "white",
    transform: "translate(0 59)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5513_14830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.1893,
    height: 62.7733,
    fill: "white",
    transform: "translate(34.7202)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCupPodiumNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cup-podium-new.23ecc805.svg";
export { ForwardRef as ReactComponent };